import {Component, inject, Input} from '@angular/core';
import {MatTooltipModule} from "@angular/material/tooltip";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-restricted-indicator',
  templateUrl: './restricted-indicator.component.html',
  styleUrls: ['./restricted-indicator.component.scss'],
  standalone: true,
  imports: [MatTooltipModule]
})
export class RestrictedIndicatorComponent {
  private readonly translate = inject(TranslateService);

  @Input() label: string | null = null;

  get tooltip(): string {
    return this.label?.trim()
      ? this.label
      : this.translate.instant('TRANS__FIELD__IS_RESTRICTED');
  }
}
